import React from 'react'
import { Button, DataPreview, Row, Skeleton, H2, Subheading } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { ContentEdit } from '@fs/zion-icon'
import RequestStatus from './RequestStatus'

const SettingsCard = ({ id, heading, subHeading, onClick, loading, children, linesHint = 1 }) => {
  const { t } = useTranslation()
  // show DataPreview loading if loading prop is true otherwise rely on DataPreview.Provider to control DataPreview loading
  const directLoading = loading ? true : undefined
  const editHeading = heading && (
    <H2 size="H5">
      {heading} <Subheading>{subHeading}</Subheading>
    </H2>
  )
  const headingWithButton = onClick ? (
    <Row alignY="middle" wrap guttersY="none">
      {editHeading}
      <div>
        <DataPreview.Ready>
          <Button Icon={ContentEdit} emphasis="low" id={`${id}-edit-button`} onClick={onClick} disabled={loading}>
            {t('common-ui:edit.action', 'Edit')}
          </Button>
        </DataPreview.Ready>
      </div>
    </Row>
  ) : (
    editHeading
  )
  return (
    <div>
      {headingWithButton}
      <RequestStatus loading={loading} invisible />
      <DataPreview.Ready loading={directLoading}>{children}</DataPreview.Ready>
      <DataPreview.Loading loading={directLoading}>
        <Skeleton.Paragraph lineCount={linesHint} size="md" />
      </DataPreview.Loading>
    </div>
  )
}
export default SettingsCard
